import styled from "styled-components";
import {JackpotBetPrizeAmountContainerDefaultBox} from "./jp-bet-prize-amount.default.box";

export const JackpotBetPrizeAmountContainerMRGBox = styled(JackpotBetPrizeAmountContainerDefaultBox)`
  background: linear-gradient(270deg, #F8F195 0.11%, #F8F3CA 50.11%, #F8F195 100.11%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

`;
